import { createFileRoute, useLoaderData } from '@tanstack/react-router'
import { apiRetrieveImproved } from '@/api.ts'
import BlogPage from '../../../landing/BlogPage'
import { PostType } from '@/constants.ts'
import { Post } from '@/types'

export const Route = createFileRoute('/blog/page/$page_number')({
  loader: async () => {
    const posts = await apiRetrieveImproved('public-blog', { type: PostType.Blog }) as Post[];
    return { posts };
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { posts } = useLoaderData({ from: '/blog/page/$page_number' });
  return <BlogPage initialPosts={posts} />
}
